(function() {
  const toggleCollageImages = () => {
    const isMobile = window.innerWidth <= 991;
    
    // 1. Target ONLY the image-side slider, not the text tabs
    // We use the specific class .collage-with-tabs-item combined with the swiper class
    const imageSliders = document.querySelectorAll('.collage-with-tabs-item.swiper-container, .collage-with-tabs-item.swiper');
    
    // 2. Target the text side (the accordion) to expand it
    const textAccordion = document.querySelector('.collage-with-tabs-item:not(.swiper-container):not(.swiper)');

    imageSliders.forEach(slider => {
      if (isMobile) {
        slider.style.setProperty('display', 'none', 'important');
      } else {
        slider.style.removeProperty('display');
      }
    });

    if (textAccordion) {
      if (isMobile) {
        textAccordion.style.setProperty('flex', '0 0 100%', 'important');
        textAccordion.style.setProperty('width', '100%', 'important');
        textAccordion.style.setProperty('display', 'block', 'important');
      } else {
        textAccordion.style.removeProperty('flex');
        textAccordion.style.removeProperty('width');
        textAccordion.style.removeProperty('display');
      }
    }
  };

  toggleCollageImages();
  window.addEventListener('resize', toggleCollageImages);

  const observer = new MutationObserver(toggleCollageImages);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();